import { useTheme } from "../../hooks/useTheme";
import { motion } from "framer-motion";
import { CheckCircle, AlertCircle, Package, User } from "lucide-react";

interface ConfirmationModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  formData: {
    name: string;
    email: string;
    phone: string;
  };
  cartItems: {
    items: any[];
    totalAmount: number;
  };
}

export function ConfirmationModal({ isOpen, onClose, onConfirm, formData, cartItems }: ConfirmationModalProps) {
  const theme = useTheme(state => state.getThemeStyles());
  
  if (!isOpen) return null;

  const handleConfirm = () => {
    onConfirm();
    onClose();
  };

  return (
    <motion.div 
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      className={theme.components.confirmationModal.wrapper}
    >
      <div 
        className={theme.components.confirmationModal.overlay}
        onClick={onClose}
      />
      
      <motion.div 
        initial={{ scale: 0.9, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        exit={{ scale: 0.9, opacity: 0 }}
        className={theme.components.confirmationModal.container}
      >
        <div className={theme.components.confirmationModal.header.wrapper}>
          <CheckCircle className="w-6 h-6 text-cyan-400 mr-2" />
          <h2 className={theme.components.confirmationModal.header.title}>
            Confirmar Envio
          </h2>
        </div>

        <div className={theme.components.confirmationModal.content.wrapper}>
          <div className={theme.components.confirmationModal.alert.wrapper}>
            <AlertCircle className="w-5 h-5 text-cyan-400" />
            <p className={theme.components.confirmationModal.alert.text}>
              Confira os dados antes de enviar
            </p>
          </div>
          
          <div className={theme.components.confirmationModal.content.section}>
            <div className={theme.components.confirmationModal.content.header}>
              <Package className="w-5 h-5 text-cyan-400" />
              <h3 className={theme.components.confirmationModal.content.title}>
                Dados do Pedido
              </h3>
            </div>
            <ul className={theme.components.confirmationModal.content.list}>
              <li className="flex items-center justify-between">
                <span>Total de arquivos:</span>
                <span className="font-medium">{cartItems.items.length}</span>
              </li>
              <li className="flex items-center justify-between">
                <span>Valor total:</span>
                <span className="font-medium text-cyan-400">
                  R$ {cartItems.totalAmount.toFixed(2)}
                </span>
              </li>
            </ul>
          </div>

          <div className={theme.components.confirmationModal.content.section}>
            <div className={theme.components.confirmationModal.content.header}>
              <User className="w-5 h-5 text-cyan-400" />
              <h3 className={theme.components.confirmationModal.content.title}>
                Dados do Cliente
              </h3>
            </div>
            <ul className={theme.components.confirmationModal.content.list}>
              <li className="flex items-center justify-between">
                <span>Nome:</span>
                <span className="font-medium">{formData.name}</span>
              </li>
              <li className="flex items-center justify-between">
                <span>Email:</span>
                <span className="font-medium">{formData.email}</span>
              </li>
              <li className="flex items-center justify-between">
                <span>Telefone:</span>
                <span className="font-medium">{formData.phone}</span>
              </li>
            </ul>
          </div>
        </div>

        <div className={theme.components.confirmationModal.footer.wrapper}>
          <button
            onClick={handleConfirm}
            className={theme.components.confirmationModal.footer.button.confirm}
          >
            Confirmar e Enviar
          </button>
          <button
            onClick={onClose}
            className={theme.components.confirmationModal.footer.button.cancel}
          >
            Voltar
          </button>
        </div>
      </motion.div>
    </motion.div>
  );
}